<template>
  <div class="index-con">
    <!-- 泡面大叔 -->
    <img-description :title="obj1.title" :url="obj1.url" :desc="obj1.desc"></img-description>
    <!-- 设备介绍 -->
    <swiper :title="obj2.title" :imgs="obj2.imgs" :desc="obj2.desc" :img-height="478" :img-width="950"></swiper>
    <!-- 泡面介绍 -->
    <swiper :title="obj3.title" :imgs="obj3.imgs" :desc="obj3.desc" :img-height="481" :img-width="955"></swiper>
    <!-- 场景介绍 -->
    <swiper :title="obj4.title" :imgs="obj4.imgs" :desc="obj4.desc" :img-height="482" :img-width="956"></swiper>
    <!-- 场景介绍 -->
    <swiper :title="obj5.title" :imgs="obj5.imgs" :desc="obj5.desc" :img-height="859" :img-width="1500"></swiper>
  </div>
</template>

<script>
import Swiper from '@/components/content/Swiper'
import ImgDescription from '@/components/content/ImgDescription'
export default {
  name: 'homepage',
  components: {
    Swiper,
    ImgDescription
  },
  props: {
    lang: {
      type: String,
      default: 'zh'
    }
  },
  computed: {
    obj1() {
      return {
        'url': require("@/assets/images/homePage1.jpg"),
        'title': this.lang === 'zh' ? '泡面大叔' : 'Uncle Noodle',
        'desc': this.lang === 'zh'
        ? `泡面大叔品牌不遗余力<br/>
        向更多人介绍世界各国的泡面，<br/>
        宣传泡面的历史、故事、分享泡面的煮法<br/>
        和特色食用方法，以及各种泡面相关周边产品，<br/>
        以泡面为主的特色饮食文化影响更多人的舌尖。`
        : `The brand of instant noodles has spared no effort to introduce instant noodles from all over the world to more people, <br/>
        publicize the history and stories of instant noodles, share the cooking methods and special eating methods of instant noodles, <br/>
        and all kinds of products related to instant noodles. The special diet culture, which focuses on instant noodles, has influenced more people.`
      }
    },
    obj2() {
      return {
        'imgs': this.lang === 'zh'
        ? [
          require("@/assets/images/equipment/zh/equipmentIntroduction.png"),
          require("@/assets/images/equipment/zh/source1.png"),
          require("@/assets/images/equipment/zh/source2.png"),
          require("@/assets/images/equipment/zh/source3.png")
        ]
        : [
          require("@/assets/images/equipment/en/equipmentIntroduction.png"),
          require("@/assets/images/equipment/en/source1.jpg"),
          require("@/assets/images/equipment/en/source2.jpg"),
          require("@/assets/images/equipment/en/source3.jpg")
        ],
        'title': this.lang === 'zh' ? '设备介绍' : 'Equipment Introduction',
        'desc': this.lang === 'zh'
        ? `智能烹饪机的出现弥补了在生活、娱乐、<br/>
        工作场景下即时烹饪需求的空白，<br/>
        满足了有即食热餐需求的消费者，<br/>
        提供了更多餐食的选择。`
        : `The emergence of intelligent cooking machine makes up for the gap of instant cooking demand in life, <br/>
        entertainment and work scenes, meets the needs of consumers with instant hot meals, and provides more choices of meals.`
      }
    },
    obj3() {
      return {
        'imgs': this.lang === 'zh'
        ? [
          require("@/assets/images/noodle/zh/noodle1.jpg"),
          require("@/assets/images/noodle/zh/noodle2.jpg")
        ]
        : [
          require("@/assets/images/noodle/en/noodle1.jpg"),
          require("@/assets/images/noodle/en/noodle2.jpg")
        ],
        'title': this.lang === 'zh' ? '泡面介绍' : 'Instant noodles Introduction',
        'desc': this.lang === 'zh'
        ? `泡面大叔为你打造了一个的世界泡面集中地，<br/>
        合作各国知名泡面源头的厂商，<br/>
        真正实现了世界泡面一站式挑选。<br/>
        我们不生产泡面，我们只是泡面的搬运工！`
        : `Uncle noodle has created a world instant noodle center for you, cooperated with famous instant noodle source manufacturers in various countries, <br/>
        and truly realized one-stop selection of instant noodles in the world. We don't produce instant noodles, we are just porters of instant noodles!`
      }
    },
    obj4() {
      return {
        'imgs': [
          require("@/assets/images/scene/scene1.png"),
          require("@/assets/images/scene/scene2.png"),
          require("@/assets/images/scene/scene3.png"),
          require("@/assets/images/scene/scene4.png"),
          require("@/assets/images/scene/scene5.png"),
          require("@/assets/images/scene/scene6.png")
        ],
        'title': this.lang === 'zh' ? '场景介绍' : 'Scenario Introduction',
        'desc': this.lang === 'zh'
        ? `便利店、食堂、影院、移动餐车、茶室、网咖、<br/>
        茶水间、自助餐厅、无人24小时营业泡面小食堂...<br/>
        我们甚至还有自助售货烹饪一体机适合任何场合，<br/>
        只有你想不到，没有我们做不到。`
        : `Convenience stores, canteens, cinemas, mobile dining cars, teahouses, internet cafes, tea rooms, cafeterias, instant noodles small canteen that are unmanned 24 hours a day...... <br/>
        There are many more<br/>
        We even have a self-service cooking machine suitable for any occasion,only you can't think of it,nothing we can’t do.`
      }
    },
    obj5() {
      return {
        'imgs': [
          require("@/assets/images/home/1.jpg"),
          require("@/assets/images/home/2.jpg"),
          require("@/assets/images/home/3.jpg"),
          require("@/assets/images/home/4.jpg"),
          require("@/assets/images/home/5.jpg")
        ],
        'title': this.lang === 'zh' ? '线下体验' : 'Offline experience',
        'desc': this.lang === 'zh'
        ? `我们正在积极筹备更多的线下体验馆和<br/>
        以“泡面”为主题的博物乐园来呈现给大家！<br/>
        一起来感受不同国家的泡面文化、泡面手办<br/>
        以及世界各国丰富多彩的泡面风味！
        `
        : `We are actively preparing for more offline experience stores and to "Instant noodles" as the<br/>
        theme of the museum to present to you!<br/>
        Let's experience the instant noodle culture of different countries, Garage Kits of instant noodle and the colorful flavor of instant noodles<br/>
         around the world!
        `
      }
    }
  }
}
</script>

<style lang="less">
.index-con {
  background-color: #ebebeb;
}
</style>



// WEBPACK FOOTER //
// src/components/content/homepage/homepage.vue